export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6567.5a17c501.jpg";